import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=0a1d6d65&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=0a1d6d65&prod&lang=scss"
import style1 from "./Gallery.vue?vue&type=style&index=1&id=0a1d6d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d6d65",
  null
  
)

export default component.exports